export default "__VITE_ASSET__TJta5gWF__"